import { cn } from "@repo/utils/cn";
import { ComponentProps } from "react";
import { Slot } from "radix-ui";

export type ContainerProps = {
  asChild?: boolean;
  nested?: boolean;
  className?: string;
  separator?: "borderMuted" | "borderCropped" | "";
} & (
  | {
      asChild: true;
      children?: React.ReactNode;
    }
  | ({
      asChild?: false;
    } & ComponentProps<"div">)
);

export function Container({
  asChild,
  nested,
  className,
  separator,
  children,
  ...props
}: ContainerProps) {
  const Component = asChild ? Slot.Root : "div";

  return (
    <>
      <Component
        className={cn(
          "ui:mx-auto ui:grid ui:w-full ui:grid-cols-12 ui:gap-x-containerGutter ui:gap-y-sectionVertical",
          { "ui:px-container ui:xl:max-w-[1440px]": !nested },
          className,
        )}
        {...props}
      >
        {children}
      </Component>

      {separator === "borderMuted" && (
        <hr className="ui:m-0 ui:h-px ui:w-screen ui:border-0 ui:bg-borderMuted" />
      )}

      {separator === "borderCropped" && (
        <hr className="ui:m-0 ui:mx-auto ui:h-px ui:w-full ui:max-w-[1440px] ui:border-0 ui:bg-borderMuted" />
      )}
    </>
  );
}
